import { Component } from 'react';
import PropTypes from 'prop-types';
import { getParameterByName } from '../utility/queryStringHelper';
import withDonate from './guest/WithDonate';
import * as AppActions from '../actions/AppActions';
import _get from 'lodash/get';
import templateData from '../utility/getTemplateData';
import { isLoggedInUser, isOneTouchUser } from '../utility/authUtils';
import * as FPT from '../utility/fpt';
import { EVENT_NAME } from '../utility/constants';

class CaptureOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: '',
      accessToken: '',
      isSubmitted: false,
      backBtnVisible: false,
      responseData: '',
      wTransactionEntry: '',
      requestError: '',
    };
  }

  componentDidMount() {
    this.props.toggleSpinner(true);
    const donateToken = getParameterByName('dtoken');
    const orderToken = getParameterByName('token');
    const payerID = getParameterByName('PayerID');

    this.captureOrder(orderToken, donateToken, payerID);
  }

  captureOrder = (orderToken, donateToken, payerID) => {
    this.props
      .captureOrder(orderToken, donateToken, payerID)
      .then((response) => response.json())
      .then((result) => {
        if (_get(result, 'data.orderData.status') !== 'COMPLETED') {
          this.props.history.push('/donate/error/payment');
          return;
        }

        const isMemberFlow = isLoggedInUser() || isOneTouchUser();
        const confirmationData = _get(result, 'data.confirmationData', {});
        this.handlePaymentSuccess(confirmationData, isMemberFlow);
      })
      .catch(() => {
        this.props.history.push('/donate/error/payment');
      });
  };

  handlePaymentSuccess = (response, isMemberFlow) => {
    AppActions.updateConfirmation({ confirmation: response });
    this.handleConfirmation(response, isMemberFlow);
  };

  handleConfirmation = (response, isMemberFlow) => {
    const { token } = templateData;
    const flow = isMemberFlow ? 'member' : 'guest';
    const page = response.isOfacPending ? 'pending' : 'confirmation';
    const url = token
      ? `/donate/${flow}/${page}/?token=${token}`
      : `/donate/${flow}/${page}`;
    const eventName = response.isOfacPending
      ? EVENT_NAME.DW_GIVING_PAYMENT_PENDING_SCREEN_SHOWN
      : EVENT_NAME.DW_GIVING_PAYMENT_SUCCESS_SCREEN_SHOWN;

    const pageTrack = `main:donate:wps:${flow}:${
      response.isOfacPending ? 'pending' : 'success'
    }`;
    FPT.trackExternalFlowData();
    FPT.trackToken();
    FPT.trackPageWithData(pageTrack, `${pageTrack}:web::`, {
      trid: response.confirmationNumber ?? '',
      event_name: eventName,
      account_type: flow,
      amount: response.postBackData?.mc_gross,
      currency: response.postBackData?.mc_currency,
      order_id: response.orderId,
    });

    this.props.history.push(url);
  };

  render() {
    return null;
  }
}

CaptureOrder.propTypes = {
  toggleSpinner: PropTypes.func,
  captureOrder: PropTypes.func,
  history: PropTypes.object,
};

export default withDonate(CaptureOrder);
